export default {
    getHomeAccordions: state => state.homeAccordions,
    getLoadingStatus: state => state.loading,
    getAccordionContent: state => accordion => {
        return state[accordion]
    },
    getLawlexRecentSearches: state => state.lawlexRecentSearches,
    getLawlexUsSavedSearches: state => state.lawlexUsSavedSearches,
    getEurlexSavedSearches: state => state.eurlexSavedSearches,
    getLawlexLoadingStatus: state => state.getLawlexLoadingStatus,
}
